import _bundle from './index'
export const bundle = _bundle

import _storeV1 from '../core/store/v1'
export const storeV1 = _storeV1

import _serverV1 from '../core/server/v1'
export const serverV1 = _serverV1

import _urlV1 from '../core/url/v1'
export const urlV1 = _urlV1

import _cookiesV1 from '../core/cookies/v1'
export const cookiesV1 = _cookiesV1

import _apiV1 from '../core/api/v1'
export const apiV1 = _apiV1

import presetV1 from './presets/v1'
export const presets = {
    v1: presetV1
}
